import { useParams } from "react-router-dom";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const PaymentStatus = () => {
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null);
  const { status, id } = useParams(); // Extract both status and id
  const navigate = useNavigate();
  console.log('entered')

  useEffect(() => {
    console.log(id)

    console.log('entered1')

    const checkPaymentStatus = async () => {
      console.log('entered3')
      try {
        console.log('entered8')
        console.log(backendbaseUrl)

        const response = await axios.post(
          `${backendbaseUrl}/users/check-payment-status/`,
          {"track_id":id}
         
        );
        console.log('entered4')

        console.log("Payment Response:", response); // Debugging log

        if (response?.status === 200) {
          setPaymentStatus(response?.data?.payment_status);

          // Delay navigation to ensure state updates
          setTimeout(() => {
            navigate(`/login`);
          }, 3000);
        } else {
          console.log('error')
          setPaymentStatus(response.data.error);
        }
      } catch (error: any) {
        console.error("Payment API Error:", error); // Debugging log
        setPaymentStatus(error.response?.data?.error);
      }
    };
   
    checkPaymentStatus();
  }, []); // Effect runs when `id` changes

  return (
    <div className="payment-status-wrapper horizontal-wrapper" id="pageWrapper">
      <div className="status-wrapper">
        <div className="container">
          <DotLottieReact
            src={
              status === "success"
                ? "https://lottie.host/23e2e155-2cb0-4892-bd4e-ec69b25c2b5c/H0KJwuLmiJ.lottie"
                : "https://lottie.host/6e747325-0e7a-44d4-9bbe-4442eefb2928/MAkHHBTBYp.lottie"
            }
            loop
            autoplay
          />

          <p className="text-center">
            {paymentStatus}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;
